/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-04-13 15:04:06
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-04-16 13:48:51
 * @FilePath: \lowsky\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import ResourcesView from '../views/ResourcesView.vue'
import SupplyDemandView from '../views/SupplyDemandView.vue'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: HomeView
  // },
  {
    path: '/resources',
    name: 'resources',
    component: ResourcesView
  },
  {
    path: '/main',
    name: 'supply-demand',
    component: SupplyDemandView
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
